// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "./default/chunk-article-listed.02a163b2e183c562b67c.js";
	if (chunkId === 36) return "./default/chunk-subscription.f13eca7f9023d5d1c441.js";
	if (chunkId === 64) return "./64.f8b5bedcefb3f67ab307.js";
	if (chunkId === 34) return "./default/chunk-small-gallery.752585edd0fabacfe975.js";
	if (chunkId === 30) return "./default/chunk-photo-credit-toogle.bd199c72405f48eca60a.js";
	if (chunkId === 35) return "./default/chunk-social-click.bd1ef60b81d1e31316c8.js";
	if (chunkId === 38) return "./default/chunk-table.ad131c002ca4e3afe5fc.js";
	if (chunkId === 42) return "./default/gallery-in-art-preserve-scroll.04f93d45d986ecd17110.js";
	if (chunkId === 65) return "./65.bfe9b4a5cc1acecf37a8.js";
	if (chunkId === 29) return "./default/chunk-online-reports.dc4a2bc47b638b96c243.js";
	if (chunkId === 5) return "./chunk-league-table.806a646eccb033a544ba.js";
	// return url for filenames based on template
	return undefined;
};